import SearchPage from '../components/SearchPage';
import { StoreState } from '../types/index';
import { connect } from 'react-redux';
import { SearchAction, changeSearchText } from '../actions/SearchActions';
import { Dispatch } from 'redux';

export function mapStateToProps({ search }: StoreState) {
    return {
        searchText: search.text,
        searchResults: search.results,
    };
}

export function mapDispatchToProps(dispatch: Dispatch<SearchAction>) {
    return {
        onChangeSearchText: (text: string) => {
            dispatch(changeSearchText(text)); 
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);